import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export enum SelectThemes {
  default = 'default',
  basic = 'basic',
  transparent = 'transparent',
  concrete = 'concrete',
}

@Component({
  selector: 'sd-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectComponent {
  @Input() theme: SelectThemes = SelectThemes.default;

  @HostBinding('class')
  get classNames(): string[] {
    return ['sd-select', this.theme && `sd-select-theme-${this.theme}`].filter(Boolean);
  }
}
